import { ThemeInput } from "./tokens";

export default {
  dark: false,
  colors: {
    "primary": "#38AF49",
    "on-primary": "#ffffff",
    "secondary": "#FBDE18",
    "on-secondary": "#1d4c39",
    "tertiary": "#012169",
    "on-tertiary": "#ffffff",
    "error": "#FF5252",
    "on-error": "#ffffff",
    "background": "#eeeeee",
    "on-background": "#000000",
    "surface": "#F8F8F8",
    "on-surface": "#494949",
    "dark-background": "#38AF49",
    "on-dark-background": "#ffffff",
    "content-background": "#F8F8F8",
    "on-content-background": "#000000",
    "heading": "#ffffff",
    "body": "#D4D4D4",
    "info": "#2196F3",
    "on-info": "#ffffff",
    "success": "#302681",
    "on-success": "#ffffff",
    "warning": "#FB8C00",
    "on-warning": "#ffffff",
    "stripes-background": "#FBDE18",
    "on-stripes-background": "#1d4c39",
  },
  variables: {},
} satisfies ThemeInput;
